import { render, staticRenderFns } from "./GamePsData.vue?vue&type=template&id=4de2c6e1&scoped=true"
import script from "./GamePsData.vue?vue&type=script&lang=js"
export * from "./GamePsData.vue?vue&type=script&lang=js"
import style0 from "./GamePsData.vue?vue&type=style&index=0&id=4de2c6e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de2c6e1",
  null
  
)

export default component.exports